import classnames from 'classnames';
import React from 'react';

const DefaultTabButton: React.FC<{
    className?: string;
    label: string;
    selected?: boolean;
}> = ({ className, label, selected }) => {
    return (
        <button
            className={classnames(
                className,
                'relative py-12 z-10 border-b-2',
                selected ? '' : 'border-transparent opacity-60',
                'text-body-bold-16 lg:text-body-bold-18 text-overline-16-custom-style',
                selected ? 'border-[var(--primary-color)]' : 'border-transparent'
            )}>
            {label}
        </button>
    );
};

export default DefaultTabButton;
